import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {propTypes, defaultProps} from 'react-props-decorators';
import classNames from 'classnames';

import Page from 'components/ui/page';

import nl2br from 'react-nl2br';

import _ from 'lodash';

import './news.less';
import {connect} from "react-redux";
import {getNews, getTags} from "store/reducers/news";
import moment from "moment";
import formats from "dictionaries/formats";
import {Link} from "react-router";
import GlobalLoaderComponent from "components/ui/global-loader";
import renderHTML from 'react-render-html';

@connect((state) => ({}), {getTags})

export default class TagsComponent extends Component {

    state = {
        tags: [],
    };

    componentWillMount() {
        this.loadTags();
    }

    async loadTags() {
        const response = await this.props.getTags();

        if (response.isOk) {
            this.setState({
                tags: _.orderBy(response.payload.items, ['count'], ['desc']),
            });
        } else {
            response.showErrors();
        }
    }

    render() {
        return (
            <div className="tags">
                <div className="sidebar__title">Популярные теги</div>
                <div className="tag-list">
                    {this.state.tags.map(::this.renderTag)}
                </div>
            </div>
        );
    }

    renderTag(tag) {
        const {name} = tag;

        return (
            <a key={name} href="javascript:void(0)" onClick={this.showTag.bind(this, name)} className="tag-item b-button b-button_shadow_gray b-button_white b-button_size_md">{name}</a>
        );
    }

    showTag(tag) {
        this.props.router.push(`/news/tag/${tag}`);
    }
}


// WEBPACK FOOTER //
// ./src/components/modules/news/tags.js